<template>
  <section v-if="!isPageLoading" class="design">
    <div class="design__wrapper">
      <div v-for="course in allCourses" :key="course.id" class="design__course">
        <CourseTile
          :course="course"
          :backgroundImg="course.images.small_image_url"
          :gradient="$getGradient()"
          :duration="course.duration || '0:00:00'"
          :link="$buildContentLink('course', course)"
          :customClass="'design__course-tile'"
          :isFreeTrialUser="isFreeTrialUser"
        />
        <div class="design__course-id">{{ course.id }}</div>
      </div>
    </div>
  </section>
  <section v-else class="design__loader-wrapper">
    <LoadingSpinner />
  </section>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { createIndices } from '@/services/search'
import LoadingSpinner from '@/components/loaders/LoadingSpinner.vue'
import CourseTile from '../components/layout/CourseTile.vue'

export default {
  name: 'Design',
  metaInfo() {
    return {
      title: `INE - All Courses`,
      meta: [
        {
          vmid: 'robots',
          name: 'robots',
          content: 'noindex',
        },
      ],
    }
  },
  components: {
    CourseTile,
    LoadingSpinner,
  },
  data: () => {
    return {
      hasReachedBottom: false,
      indices: {
        AllCourses: {},
      },
      courses: {
        AllCourses: [],
      },
      pages: {
        AllCourses: {
          currentPage: 0,
          totalPages: 0,
        },
      },
      allCourses: [],
    }
  },
  watch: {
    hasReachedBottom(bottom) {
      if (bottom) {
        this.loadMore()
      }
    },
  },
  computed: {
    ...mapState({
      isPageLoading: state => state.app.isPageLoading,
      algoliaKeys: state => state.search.algoliaKeys,
    }),
    ...mapGetters({
      isFreeTrialUser: 'auth/isFreeTrialUser',
    }),
  },
  methods: {
    loadMore() {
      const { currentPage, totalPages } = this.pages.AllCourses
      if (currentPage !== totalPages) {
        this.indices.AllCourses.nextPage()
        this.indices.AllCourses.search()
      }
    },
    handleResults(index, { hits, page, nbPages }) {
      this.pages[index].currentPage = page
      this.pages[index].totalPages = nbPages
      if (this.pages[index].currentPage === 0) {
        this.allCourses = hits
      } else {
        this.allCourses = [...this.allCourses, ...hits]
      }
    },
    createSearchInstance() {
      const {
        algoliaKeys: { appKey, appId, coursesIndex: courses },
      } = this
      const allCourses = {
        keys: {
          appId,
          appKey,
        },
        contexts: [
          {
            name: 'AllCourses',
            index: courses,
            facets: [],
          },
        ],
        resultsHandler: this.handleResults,
      }
      const { indices } = createIndices(allCourses)
      this.indices = indices
    },
    isBottomVisible() {
      const scrollY = window.scrollY
      const visible = document.documentElement.clientHeight
      const pageHeight = document.documentElement.scrollHeight
      const bottomOfPage = visible + scrollY >= pageHeight - 1000
      return bottomOfPage || pageHeight < visible
    },
  },
  async created() {
    this.$store.dispatch('app/setIsPageLoading', true)
    this.createSearchInstance()
    window.addEventListener('scroll', () => {
      this.hasReachedBottom = this.isBottomVisible()
    })
    this.$store.dispatch('app/setIsPageLoading', false)
  },
  destroyed() {
    window.removeEventListener('scroll', () => null)
  },
}
</script>

<style lang="scss">
.design {
  padding: 150px 25px;
  &__wrapper {
    display: flex;
    flex-wrap: wrap;
    flex-grow: 1;
  }
  &__course {
    width: 100%;
    @include mobile {
      width: 50%;
    }
    @include desktop {
      width: 25%;
    }
    display: flex;
    flex-wrap: wrap;
  }
  &__course-tile {
    width: 100%;
  }
  &__course-id {
    margin: 0 auto 25px auto;
    color: var(--orange);
  }
}
</style>
